define('lq/events/actions/validateCommand',[
    'lq/events/actions/eventAction',
    'lq/validations'
], function (EventAction, validations) {
    'use strict';

    function ValidationCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(ValidationCommand, EventAction);

    ValidationCommand.typeName = 'ValidateCommand';

    ValidationCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    ValidationCommand.prototype.execute = function (continuation) {
        validations.runValidation(this.eventData.validation, this.piping, this.triggerValidationEvent.bind(this))
            .done(this.afterValidationCompleted.bind(this, continuation), this.afterValidationFailed.bind(this, continuation));
    };

    // a validation condition couldn't be evaluated: stop the event, like create and update do
    ValidationCommand.prototype.afterValidationFailed = function (continuation, e) {
        continuation({ break: true });
        this.piping.errorHandler.showErrorDialog(e);
    };

    ValidationCommand.prototype.triggerValidationEvent = function (eventName) {
        this.piping.eventing.publish(eventName, this.eventSource, null, null, this.getEventActionIdentifier());
    };

    ValidationCommand.prototype.afterValidationCompleted = function (continuation, isEverythingValid) {
        if (isEverythingValid && this.eventIsEnabled('inputValidated')) {
            this.triggerEvent('inputValidated', continuation);
        } else if (!isEverythingValid && this.eventIsEnabled('inputInvalidated')) {
            this.triggerEvent('inputInvalidated');
        }

        continuation();
    };    

    return ValidationCommand;
});
